module.exports = __webpack_public_path__ + "img/744.7a4a3714.jpg";